import './confirmation.html';
import { DetailDialogController } from '../../../controller/DetailDialogController';
import { ADMINISTRATION_USER_ACC, deleteAccounts } from '../../../services/arsweb/RoutingPaths';
import { HTTPService } from 'fides-angularjs-components/src/fts-services/fts-http-service';

/** @ngInject */
export class SendReportingDeleteConfirmationController extends DetailDialogController {
    constructor($scope, userService, arsMainDependencies) {

        super($scope, userService, arsMainDependencies, arsMainDependencies.$state.params.restUrl,
          new HTTPService(userService.fsMainDependencies));

        this.selectedItems = arsMainDependencies.$state._params.ids;
    }

    delete() {
        this.element = this.state.filter;
        this.element.loadKey = this.selectedItems;

        this.detailviewDataPromise = this.service.post( ADMINISTRATION_USER_ACC + deleteAccounts, this.element)
          .then(() => this.successPop('DELETE_ACCOUNT_SUCCESS'))
          .catch(() => this.errorPop('DELETE_ACCOUNT_ERROR'));

        this.closeDialog();
    }
}
